module.exports = __webpack_public_path__ + "media/images/phone-c69c55ed.png";